// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container.folders{
  
}
.calender-container.images{
  width:400px;
  left:1rem;
  margin-top:0;
  top:50%;
}
.title-container-right.images{
  display: flex;
  align-items: center;
  gap:1rem;
}
.clear-filter-button{
  color:rgb(238, 151, 73);
  background-color: transparent;
  border: none;
}
.download-button {
  border: 1px solid rgb(51, 69, 157);
  background-color: rgb(51, 69, 157);
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
  color:white;
}
.report-records-container.folder-page{
  width:100%;
  height:calc(100% - 4rem);
  display: flex;
  flex-direction:column;
  gap:1rem;
  padding:1rem;
  overflow-y: scroll;
  overflow-x: hidden;
}
.each-parent-container.folder{
  display:grid;
  grid-template-columns: repeat(5,1fr);
  gap:1rem;
  width:100%;
}
.calender-button{
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 2rem;
  outline: none;
  border: 1px solid rgb(204, 212, 224);
  background-color: white;
  border-radius: 0.25rem;
  padding: 0rem 0rem 0rem 0.25rem;
  color:rgb(74, 85, 103);
}
.calender-button-in-image-container.images{
  width:-moz-fit-content;
  width:fit-content;
  padding:4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height:100%;
  background-color: rgb(211, 185, 49);
}
.images-selected-container{
  width:100%;
  position:absolute;
  bottom:0%;
  background-color: white;
  padding:1.5rem;
  display:flex;
  align-items: center;
  justify-content: flex-end;
  gap:1rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.date-record-container.folder{
  width:100%;
  border-bottom:1px solid rgb(192, 194, 199);
}
.date-record-container.folder span{
   font-weight: 600;
   font-size: medium;
}
.folders-main-container.folder{
  display:grid;
  grid-template-columns: repeat(5,1fr);
  gap:1rem;
  width:100%;
  /* padding:1rem; */
}
.each-folder.folder.main{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width:100%;
  background-color: rgb(249, 249, 249);
  gap:0.5rem;
  padding:1rem;
  height:100%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.bay-buttons-container.images.folders{
  background-color:white;
  border-bottom: none;
}
.folder-last-modified-icon-container.folder{
  display: flex;
  align-items: flex-start;
  width:100%;
  justify-content: space-between;
  height:100%;
}
.last-modified-container{
  display: flex;
  gap:0.5rem;
  font-size: x-small;
  align-items: center;
  justify-content: space-between;
}

.sub-folder-container-folder{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height:auto;
  width:100%;
  gap:0.5rem;
}
.defect-type.folder{
  font-weight: 600;
  font-size: small;
  width:-moz-fit-content;
  width:fit-content;
}
.defect-count.folder{
  font-size: smaller;
  width:-moz-fit-content;
  width:fit-content;
}
.attribute-image-options-list{
  position:relative;
}
.calender-div-folders{
  display:flex;
  position:absolute;
  top:100%;
  /* left:10px; */
  align-items:center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index:30;
  /* width:100%; */
 }
.rdrCalendarWrapper{
  width:100%;
}
.rdrDateDisplayWrapper{
  display:none;
}
.rdrMonthAndYearWrapper{
  padding-top:0;
}
.rdrDateDisplayItemActive{
  border: 1px solid rgb(211, 185, 49) !important;
}
.rdrMonths,.rdrMonth{
  width:100%;
  align-items: center;
  justify-content: center;
}
.rdrInRange{
background-color:rgb(228, 211, 127) !important;
}
.rdrStartEdge,.rdrEndEdge{
  background-color:rgb(211, 185, 49) !important;
  color:white !important;
  /* width:80%; */
  /*height:100%; */
  /* border-radius: 50% !important; */
  /* align-items: center !important;
  justify-content: center !important; */
}
.rdrDayStartPreview,.rdrDayEndPreview{
  background-color:rgb(211, 185, 49) !important;
  color:white !important;
}
.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{
  color:white !important;
}
.rdrDayNumber{
  z-index:10;
  color:white;
}
.hidden {
  display: none;
}
@media screen and (max-width: 1500px) {

  .react-calendar__month-view__weekdays__weekday {
    font-weight: 400;
    text-decoration: none;
    flex: 0 0 14.57% !important;
    font-size: small;
  }

  .react-calendar__month-view__weekdays {
    padding-right: 10px;
    padding-left: 10px;
    padding: 0.25rem
  }

  .react-calendar {
    font-size: small;
    width: 110%;

  }
}

@media screen and (max-height: 1200px) and (min-height: 960px) {
  /* .cylinder-type-container {
    top: -3%;
  } */

  .number-plate-image {
    /* height: 5rem; */

  }

  /* .table-container-in{
    max-height:45vh
  } */
}@media screen and (max-height: 850px) and (min-height: 730px) {
  /* .cylinder-type-container {
    top: -3%;
  } */
}

@media screen and (max-height: 1200px) and (min-height: 1050px) {
  table.bay-table tbody {
    height: 54vh;
  }
  .bay-table{
    height: 52vh;
  }
}

@media screen and (max-height: 1050px) and (min-height: 960px) {
  table.bay-table tbody,.bay-table {
    height: 50vh;
  }
  .bay-table{
    height: 48vh;
  }
}

@media screen and (max-height: 960px) and (min-height: 700px) {
  .number-plate-image {
    /* height: 4rem; */

  }

  .popup-content {
    /* width: 40%; */
    /* height: 45%; */
    border-radius: 0.5rem;
  }
  .popup-content.approval-popup-content{
    width: 25%;
  }

  .dashboard-container {
    /* gap: 1.5rem; */
  }

  .bay-table-container {
    gap: 1rem;
  }

  .dropdown-buttons-container {
    /* margin-top: 3rem; */
  }

  /* .cylinder-type-container {
    top: -4%;
  } */

  /* .table-container-in{
    max-height:54vh
  } */
  table.bay-table tbody {
    height: 40vh;
  }
}
@media screen and (max-height: 960px) and (min-height: 860px) {
  
  table.bay-table tbody {
    height: 50vh;
  }
  .bay-table{
    height: 48vh;
  }
}
@media screen and (max-height: 738px) and (min-height: 300px) {
  /* .cylinder-type-container {
    top: -5%;
  } */
}
@media screen and (max-height: 780px) and (min-height: 300px) {
  .dashboard-container {
    /* gap: 1rem; */
  }

  .bay-table-container {
    gap: 1rem;
  }

  .dropdown-buttons-container {
    /* margin-top: 2.5rem; */
  }

  .number-plate-image {
    /* height: 3rem; */

  }

  .popup-content {
    /* width: 40%; */
    /* height: 45%; */
    border-radius: 0.5rem;
  }
  .popup-content.approval-popup-content{
    width: 25%;
  }

  /* .cylinder-type-container {
    top: -5%;
  } */

  .cylinder-select-button {
    font-size: small;
  }

  .shift-dropdown-contatiner {
    font-size: small;
  }

  .shift-dropdown,
  .download-button,
  .calender-button {
    font-size: small;
  }

  .bay-buttons-container {
    font-size: small;
  }

  .table-title-container {
    font-size: small;
  }

  table {
    font-size: small;
  }





}
@media screen and (max-height: 625px){
  table.bay-table tbody,.bay-table {
    height: 28vh;
  }
  .row-container {
    padding:0.25rem;
    padding-left:0;
    padding-right:0;
  }
  
}

@media screen and (max-height: 700px) and (min-height:625px){
  table.bay-table tbody,.bay-table {
    height: 30vh;
  }
}




@media screen and (max-width: 1200px) {
  .cylinder-select-button {
    font-size: 12.5px;
  }

  .cylinder-select-button {
    font-size: smaller;
  }

  .shift-dropdown-contatiner {
    font-size: smaller;
  }

  .shift-dropdown,
  .download-button,
  .calender-button {
    font-size: smaller;
  }

  .bay-buttons-container {
    font-size: smaller;
  }

  .table-title-container {
    font-size: smaller;
  }

  table {
    font-size: smaller;
  }
}

@media screen and (max-width: 1536px) {
  .cylinder-select-button {
    font-size: small;
  }
  .folders-main-container.folder{
  grid-template-columns: repeat(4,1fr);
}
  .shift-dropdown-contatiner {
    font-size: small;
  }

  .shift-dropdown,
  .download-button,
  .calender-button,
  .defect-dropdown {
    font-size: small;
  }

  .bay-buttons-container {
    font-size: small;
  }

  .table-title-container {
    font-size: small;
  }

  table {
    font-size: small;
  }

  .defects-container {
    width: 10rem;
    gap: 0.25rem;
  }

  /* .cylinder-select-button:focus{
    font-size: x-small;
  } */

  .excess-time-icon-container,
  .wheel-chock-icon-container,
  .fire-cylinder-icon-container {

    width: 2rem;
    height: 2rem;

  }
  .defect-icon{
    width:1rem;
  }
  .column-container th {
    font-size: smaller;
  }
  .truck-detail-count-container span {

    font-size:small;
  }
  .number-plate-image{
    /* width:85%; */
  }
}
@media screen and (max-width: 1360px)  {
  .folders-main-container.folder{
    grid-template-columns: repeat(4,1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/folders/main/Main.css"],"names":[],"mappings":"AAAA;;AAEA;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,QAAQ;EACR,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,sBAAiB;EAAjB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,qDAAqD;AACvD;AACA;EACE,UAAU;EACV,0CAA0C;AAC5C;AACA;GACG,gBAAgB;GAChB,iBAAiB;AACpB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oCAAoC;EACpC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAiB;EAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sBAAiB;EAAjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;CACjB;AACD;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;AACA;AACA,8CAA8C;AAC9C;AACA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC;uCACqC;AACvC;AACA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;EAEE;IACE,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB;EACF;;EAEA;IACE,gBAAgB;IAChB,WAAW;;EAEb;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,kBAAkB;;EAEpB;;EAEA;;KAEG;AACL,CAAC;EACC;;KAEG;AACL;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;;EAEpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;KAEG;;EAEH;;KAEG;EACH;IACE,YAAY;EACd;AACF;AACA;;EAEE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;;KAEG;AACL;AACA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;;EAEA;;KAEG;;EAEH;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;;;;AAMF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;;;;AAKA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;EACA,oCAAoC;AACtC;EACE;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;;KAEG;;EAEH;;;;IAIE,WAAW;IACX,YAAY;;EAEd;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".table-container.folders{\r\n  \r\n}\r\n.calender-container.images{\r\n  width:400px;\r\n  left:1rem;\r\n  margin-top:0;\r\n  top:50%;\r\n}\r\n.title-container-right.images{\r\n  display: flex;\r\n  align-items: center;\r\n  gap:1rem;\r\n}\r\n.clear-filter-button{\r\n  color:rgb(238, 151, 73);\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n.download-button {\r\n  border: 1px solid rgb(51, 69, 157);\r\n  background-color: rgb(51, 69, 157);\r\n  border-radius: 0.25rem;\r\n  padding: 0.25rem 0.5rem 0.25rem 0.5rem;\r\n  color:white;\r\n}\r\n.report-records-container.folder-page{\r\n  width:100%;\r\n  height:calc(100% - 4rem);\r\n  display: flex;\r\n  flex-direction:column;\r\n  gap:1rem;\r\n  padding:1rem;\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n.each-parent-container.folder{\r\n  display:grid;\r\n  grid-template-columns: repeat(5,1fr);\r\n  gap:1rem;\r\n  width:100%;\r\n}\r\n.calender-button{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-evenly;\r\n  height: 2rem;\r\n  outline: none;\r\n  border: 1px solid rgb(204, 212, 224);\r\n  background-color: white;\r\n  border-radius: 0.25rem;\r\n  padding: 0rem 0rem 0rem 0.25rem;\r\n  color:rgb(74, 85, 103);\r\n}\r\n.calender-button-in-image-container.images{\r\n  width:fit-content;\r\n  padding:4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height:100%;\r\n  background-color: rgb(211, 185, 49);\r\n}\r\n.images-selected-container{\r\n  width:100%;\r\n  position:absolute;\r\n  bottom:0%;\r\n  background-color: white;\r\n  padding:1.5rem;\r\n  display:flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap:1rem;\r\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n}\r\n.date-record-container.folder{\r\n  width:100%;\r\n  border-bottom:1px solid rgb(192, 194, 199);\r\n}\r\n.date-record-container.folder span{\r\n   font-weight: 600;\r\n   font-size: medium;\r\n}\r\n.folders-main-container.folder{\r\n  display:grid;\r\n  grid-template-columns: repeat(5,1fr);\r\n  gap:1rem;\r\n  width:100%;\r\n  /* padding:1rem; */\r\n}\r\n.each-folder.folder.main{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width:100%;\r\n  background-color: rgb(249, 249, 249);\r\n  gap:0.5rem;\r\n  padding:1rem;\r\n  height:100%;\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\r\n}\r\n.bay-buttons-container.images.folders{\r\n  background-color:white;\r\n  border-bottom: none;\r\n}\r\n.folder-last-modified-icon-container.folder{\r\n  display: flex;\r\n  align-items: flex-start;\r\n  width:100%;\r\n  justify-content: space-between;\r\n  height:100%;\r\n}\r\n.last-modified-container{\r\n  display: flex;\r\n  gap:0.5rem;\r\n  font-size: x-small;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sub-folder-container-folder{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  height:auto;\r\n  width:100%;\r\n  gap:0.5rem;\r\n}\r\n.defect-type.folder{\r\n  font-weight: 600;\r\n  font-size: small;\r\n  width:fit-content;\r\n}\r\n.defect-count.folder{\r\n  font-size: smaller;\r\n  width:fit-content;\r\n}\r\n.attribute-image-options-list{\r\n  position:relative;\r\n}\r\n.calender-div-folders{\r\n  display:flex;\r\n  position:absolute;\r\n  top:100%;\r\n  /* left:10px; */\r\n  align-items:center;\r\n  justify-content: center;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  z-index:30;\r\n  /* width:100%; */\r\n }\r\n.rdrCalendarWrapper{\r\n  width:100%;\r\n}\r\n.rdrDateDisplayWrapper{\r\n  display:none;\r\n}\r\n.rdrMonthAndYearWrapper{\r\n  padding-top:0;\r\n}\r\n.rdrDateDisplayItemActive{\r\n  border: 1px solid rgb(211, 185, 49) !important;\r\n}\r\n.rdrMonths,.rdrMonth{\r\n  width:100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.rdrInRange{\r\nbackground-color:rgb(228, 211, 127) !important;\r\n}\r\n.rdrStartEdge,.rdrEndEdge{\r\n  background-color:rgb(211, 185, 49) !important;\r\n  color:white !important;\r\n  /* width:80%; */\r\n  /*height:100%; */\r\n  /* border-radius: 50% !important; */\r\n  /* align-items: center !important;\r\n  justify-content: center !important; */\r\n}\r\n.rdrDayStartPreview,.rdrDayEndPreview{\r\n  background-color:rgb(211, 185, 49) !important;\r\n  color:white !important;\r\n}\r\n.rdrDayHovered > span,.rdrDayHovered > span > span,.rdrDay > span,.rdrDayInPreview{\r\n  color:white !important;\r\n}\r\n.rdrDayNumber{\r\n  z-index:10;\r\n  color:white;\r\n}\r\n.hidden {\r\n  display: none;\r\n}\r\n@media screen and (max-width: 1500px) {\r\n\r\n  .react-calendar__month-view__weekdays__weekday {\r\n    font-weight: 400;\r\n    text-decoration: none;\r\n    flex: 0 0 14.57% !important;\r\n    font-size: small;\r\n  }\r\n\r\n  .react-calendar__month-view__weekdays {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    padding: 0.25rem\r\n  }\r\n\r\n  .react-calendar {\r\n    font-size: small;\r\n    width: 110%;\r\n\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 1200px) and (min-height: 960px) {\r\n  /* .cylinder-type-container {\r\n    top: -3%;\r\n  } */\r\n\r\n  .number-plate-image {\r\n    /* height: 5rem; */\r\n\r\n  }\r\n\r\n  /* .table-container-in{\r\n    max-height:45vh\r\n  } */\r\n}@media screen and (max-height: 850px) and (min-height: 730px) {\r\n  /* .cylinder-type-container {\r\n    top: -3%;\r\n  } */\r\n}\r\n\r\n@media screen and (max-height: 1200px) and (min-height: 1050px) {\r\n  table.bay-table tbody {\r\n    height: 54vh;\r\n  }\r\n  .bay-table{\r\n    height: 52vh;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 1050px) and (min-height: 960px) {\r\n  table.bay-table tbody,.bay-table {\r\n    height: 50vh;\r\n  }\r\n  .bay-table{\r\n    height: 48vh;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 960px) and (min-height: 700px) {\r\n  .number-plate-image {\r\n    /* height: 4rem; */\r\n\r\n  }\r\n\r\n  .popup-content {\r\n    /* width: 40%; */\r\n    /* height: 45%; */\r\n    border-radius: 0.5rem;\r\n  }\r\n  .popup-content.approval-popup-content{\r\n    width: 25%;\r\n  }\r\n\r\n  .dashboard-container {\r\n    /* gap: 1.5rem; */\r\n  }\r\n\r\n  .bay-table-container {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .dropdown-buttons-container {\r\n    /* margin-top: 3rem; */\r\n  }\r\n\r\n  /* .cylinder-type-container {\r\n    top: -4%;\r\n  } */\r\n\r\n  /* .table-container-in{\r\n    max-height:54vh\r\n  } */\r\n  table.bay-table tbody {\r\n    height: 40vh;\r\n  }\r\n}\r\n@media screen and (max-height: 960px) and (min-height: 860px) {\r\n  \r\n  table.bay-table tbody {\r\n    height: 50vh;\r\n  }\r\n  .bay-table{\r\n    height: 48vh;\r\n  }\r\n}\r\n@media screen and (max-height: 738px) and (min-height: 300px) {\r\n  /* .cylinder-type-container {\r\n    top: -5%;\r\n  } */\r\n}\r\n@media screen and (max-height: 780px) and (min-height: 300px) {\r\n  .dashboard-container {\r\n    /* gap: 1rem; */\r\n  }\r\n\r\n  .bay-table-container {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .dropdown-buttons-container {\r\n    /* margin-top: 2.5rem; */\r\n  }\r\n\r\n  .number-plate-image {\r\n    /* height: 3rem; */\r\n\r\n  }\r\n\r\n  .popup-content {\r\n    /* width: 40%; */\r\n    /* height: 45%; */\r\n    border-radius: 0.5rem;\r\n  }\r\n  .popup-content.approval-popup-content{\r\n    width: 25%;\r\n  }\r\n\r\n  /* .cylinder-type-container {\r\n    top: -5%;\r\n  } */\r\n\r\n  .cylinder-select-button {\r\n    font-size: small;\r\n  }\r\n\r\n  .shift-dropdown-contatiner {\r\n    font-size: small;\r\n  }\r\n\r\n  .shift-dropdown,\r\n  .download-button,\r\n  .calender-button {\r\n    font-size: small;\r\n  }\r\n\r\n  .bay-buttons-container {\r\n    font-size: small;\r\n  }\r\n\r\n  .table-title-container {\r\n    font-size: small;\r\n  }\r\n\r\n  table {\r\n    font-size: small;\r\n  }\r\n\r\n\r\n\r\n\r\n\r\n}\r\n@media screen and (max-height: 625px){\r\n  table.bay-table tbody,.bay-table {\r\n    height: 28vh;\r\n  }\r\n  .row-container {\r\n    padding:0.25rem;\r\n    padding-left:0;\r\n    padding-right:0;\r\n  }\r\n  \r\n}\r\n\r\n@media screen and (max-height: 700px) and (min-height:625px){\r\n  table.bay-table tbody,.bay-table {\r\n    height: 30vh;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .cylinder-select-button {\r\n    font-size: 12.5px;\r\n  }\r\n\r\n  .cylinder-select-button {\r\n    font-size: smaller;\r\n  }\r\n\r\n  .shift-dropdown-contatiner {\r\n    font-size: smaller;\r\n  }\r\n\r\n  .shift-dropdown,\r\n  .download-button,\r\n  .calender-button {\r\n    font-size: smaller;\r\n  }\r\n\r\n  .bay-buttons-container {\r\n    font-size: smaller;\r\n  }\r\n\r\n  .table-title-container {\r\n    font-size: smaller;\r\n  }\r\n\r\n  table {\r\n    font-size: smaller;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1536px) {\r\n  .cylinder-select-button {\r\n    font-size: small;\r\n  }\r\n  .folders-main-container.folder{\r\n  grid-template-columns: repeat(4,1fr);\r\n}\r\n  .shift-dropdown-contatiner {\r\n    font-size: small;\r\n  }\r\n\r\n  .shift-dropdown,\r\n  .download-button,\r\n  .calender-button,\r\n  .defect-dropdown {\r\n    font-size: small;\r\n  }\r\n\r\n  .bay-buttons-container {\r\n    font-size: small;\r\n  }\r\n\r\n  .table-title-container {\r\n    font-size: small;\r\n  }\r\n\r\n  table {\r\n    font-size: small;\r\n  }\r\n\r\n  .defects-container {\r\n    width: 10rem;\r\n    gap: 0.25rem;\r\n  }\r\n\r\n  /* .cylinder-select-button:focus{\r\n    font-size: x-small;\r\n  } */\r\n\r\n  .excess-time-icon-container,\r\n  .wheel-chock-icon-container,\r\n  .fire-cylinder-icon-container {\r\n\r\n    width: 2rem;\r\n    height: 2rem;\r\n\r\n  }\r\n  .defect-icon{\r\n    width:1rem;\r\n  }\r\n  .column-container th {\r\n    font-size: smaller;\r\n  }\r\n  .truck-detail-count-container span {\r\n\r\n    font-size:small;\r\n  }\r\n  .number-plate-image{\r\n    /* width:85%; */\r\n  }\r\n}\r\n@media screen and (max-width: 1360px)  {\r\n  .folders-main-container.folder{\r\n    grid-template-columns: repeat(4,1fr);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
